import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { defaultCounterPartyConfigInputs } from './constant'

export const CounterPartyConfig = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})

  const inputs = defaultCounterPartyConfigInputs()

  useEffect(() => {
    setLoading(true)
    getAdminConfig('couterParty').then((res) => {
      setData(res)
      setLoading(false)
    })
  }, [])

  const onChange = async (key: string, value: any) => {
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
    setLoading(true)
    await setAdminConfig('couterParty', temp)
    setLoading(false)
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <div className="grid grid-cols-2 gap-2">
        {Object.keys(inputs).map((key) => {
          const input = inputs[key]
          input.value = data[key]

          return (
            <div className={`col-span-${input.span || 1}`}>
              <RenderInput input={input} Key={key} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
